export const EXTERNAL_USER_TYPE = 'external';

export const isExternalUser = (userType?: string | null): boolean => userType === EXTERNAL_USER_TYPE;

export const getRoleClaims = (roles: string | string[] | undefined | null): string[] => {
  if (Array.isArray(roles)) {
    return roles;
  }

  if (typeof roles === 'string' && roles.length > 0) {
    return [roles];
  }

  return [];
};

export const getUserDisplayName = (user?: { name?: string; full_name?: string } | null): string => user?.name || user?.full_name || '';

export const getAuthenticatedHomePath = (userType: string | undefined, isAdmin: boolean): string => {
  if (isExternalUser(userType)) {
    return '/shared';
  }

  return isAdmin ? '/admin' : '/user';
};

const decodePathname = (pathname: string): string | null => {
  try {
    return decodeURIComponent(pathname);
  } catch {
    return null;
  }
};

export const isExternalRestrictedPath = (pathname: string): boolean => {
  const normalizedPath = decodePathname(pathname);

  if (normalizedPath === null) {
    return true;
  }

  if (normalizedPath.startsWith('/admin')) {
    return true;
  }

  if (normalizedPath === '/user' || normalizedPath.startsWith('/user/')) {
    return true;
  }

  return false;
};
